import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: 'root'
})
export class WarehouseService {

	uriWarehouse: string = '/api/v1/warehouse';
	uriFilters: string = '/api/v2/filters';
	endpoint: string = environment.backend_url;

	constructor(private http: HttpClient) {
		this.http = http;
	}

	findByBuildingCodeC(buildingCodeC: number) {
		const subRoute = '/findByBuildingCodeC/';
		return this.http.get(this.endpoint + this.uriWarehouse + subRoute + buildingCodeC);
	}

	getWarehouses(idSubdivision: number) {
		const subRoute = '/getWarehouses/';
		return this.http.get(this.endpoint + this.uriFilters + subRoute + idSubdivision);
	}
}
